import { Events } from '@carvana/vdp-events';
import { useContext, useEffect } from 'react';
import UserContext from '~/context/common/UserContext';
import ModalContext from '~/context/vdp/ModalContext';
import { EventDetail } from '~/contracts/vdp';
import { useEventElements } from '~/hooks/vdp';
import { useButtonHandler } from '~/hooks/vdp/cta';
import {
  addEventListeners,
  filterLocalEvents,
  removeEventListeners
} from '~/utilities/browserEvents';

export default function useEventListeners() {
  const getStarted = useButtonHandler();
  const { setEvTaxCreditModalOpen, setCreditKarmaPromoModalOpen } =
    useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);
  const eventElements = useEventElements();

  useEffect(() => {
    // Ev Tax Credit Modal
    const handleEvTaxCreditModal = filterLocalEvents(() => {
      setEvTaxCreditModalOpen(true);
    });

    // Ck promo Modal
    const handleCreditKarmaPromoModal = filterLocalEvents(() => {
      setCreditKarmaPromoModalOpen(true);
    });

    // Get Started
    const handleGetStarted = filterLocalEvents(() => {
      getStarted();
    });

    // User Profile
    const handleUserProfile = filterLocalEvents<number>(() => {
      triggerFetchUserProfile();
    });

    addEventListeners<CustomEvent<EventDetail>>(eventElements, [
      [Events.CkPromoModalOpen, handleCreditKarmaPromoModal],
      [Events.EvTaxCreditModalOpen, handleEvTaxCreditModal],
      [Events.GetStarted, handleGetStarted],
      [Events.UserProfile, handleUserProfile]
    ]);

    return () => {
      removeEventListeners<CustomEvent<EventDetail>>(eventElements, [
        [Events.CkPromoModalOpen, handleCreditKarmaPromoModal],
        [Events.EvTaxCreditModalOpen, handleEvTaxCreditModal],
        [Events.GetStarted, handleGetStarted],
        [Events.UserProfile, handleUserProfile]
      ]);
    };
  }, [
    eventElements,
    getStarted,
    setCreditKarmaPromoModalOpen,
    setEvTaxCreditModalOpen,
    triggerFetchUserProfile
  ]);
}
